export default "__VITE_ASSET__B4ld0Zfz__"